import colors from "../base/colors";

const { info, white, gradients, text, background } = colors;



const chip = {
    styleOverrides: {
        root: ({ ownerState }) => {

            const colorMap = {
                info: {
                    background: info.main,
                    color: white.main,
                },
                success: {
                    background: gradients.success.main,
                    color: white.main,
                },
                warning: {
                    background: gradients.warning.main,
                    color: white.main,
                },
                medium: {
                    background: gradients.medium.main,
                    color: white.main,
                },
                error: {
                    background: gradients.error.main,
                    color: white.main,
                },
            };

            // ✅ 有自定义 color 才 override
            if (colorMap[ownerState.color]) {
                const current = colorMap[ownerState.color];

                return {
                    backgroundColor: current.background,
                    color: `${current.color} !important`,
                };
            }

            // ✅ 默认情况（只改成 white，不破坏其他）
            if (!ownerState.color || ownerState.color === "default") {
                return {
                    backgroundColor: white.main,
                    color: text.main,
                };
            }

            // ✅ 其他情况全部继承 MUI（关键！）
            return {};
        },

        label: {
            color: "inherit !important",
        },
    },
};

export default chip;